<template>
  <div class="pt-0 mt-0" v-if="tarifa !== null && tarifa !== undefined">    
    <div class="row">
      <div class="col-md-12">
        <table class="table">
          <!--   <thead>
            <tr>
              <th class="text-left py-3" colspan="4">
                {{ datosDog.name }}
                <span class="text-muted">({{ className }})</span>
              </th>
            </tr>
          </thead>-->
          <tbody>
            <!-- TARIFA ASIGNADA -->
            <tr>
              <td class="text-left" colspan="3" align="left">
                {{ $t('importe inscripcion') }}
                <span class="text-muted">({{ tarifa.posicion }})</span>
              </td>
              <td class="text-right">{{importeInscripcion}} €</td>
            </tr>
            <!-- DESCUENTOS -->
            <tr v-for="desc in descuentosList" :key="desc.id">
              <!--  <td scope="row">{{ desc.id }}</td> -->
              <td colspan="3" class="text-left">{{ $t(desc.tipo) }}: {{ desc.nombre }}</td>
              <td class="text-right">{{ desc.valor }}</td>
            </tr>
            <tr class="bg-total">
              <td class="text-left" colspan="3" align="left">
                <b>{{$t('total')}}:</b>
              </td>
              <td class="text-right">
                <b>{{ importeTotal }} €</b>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Ins-dog-detail",
  props: ["datosDog", "tarifa"],
  data: () => ({}),
  computed: {
    ...mapGetters("inscription", ["getselectedExpoData"]),
    importeInscripcion() {
      if (parseInt(this.tarifa.socio) === 1) {        
        return this.tarifa.precio.price_partner;
      } else {
        return this.tarifa.precio.price;
      }
      //if (tarifa.precio.price) 

    },
    className() {
      if (this.tarifa.clase === undefined) {
        return;
      }
      return this.datosDog.clases.filter(x => {
        if (x.id === this.tarifa.clase) {
          return x.class;
        }
      })[0].class;
      console.log("salida", dato[0].class);
    },
    descuentosList() {
      if (this.tarifa.descuentos.length === 0 || this.importeInscripcion === 0) {
        return;
      }
      const descuentos = this.getselectedExpoData.expo_discounts;
      let salida = [];
      this.tarifa.descuentos.forEach(x => {
        const valor =
          x.tipo === 1 ? "- " + x.descuento + " €" : "- " + x.descuento + " %";

        const nombre = descuentos.filter(d => {
          if (d.id === x.id) return d;
        })[0].name;
        salida.push({
          id: x.id,
          tipo: "descuento",
          nombre,
          valor,
          importe: x.descuento
        });
      });
      return salida;
    },
    importeTotal() {
      const tarifa = this.tarifa;
      const descuentos = tarifa.descuentos;
      let importe = this.importeInscripcion;
       // tarifa.socio === 1 ? tarifa.precio.price_partner : tarifa.precio.price;

      if (descuentos.length > 0) {
        descuentos.forEach(e => {
          const tipo = e.tipo;
          //tipo 1 importe, 2 descuento
          if (tipo === 1) {
            importe -= e.descuento;
          } else {
            importe *= 1 - e.descuento / 100;
          }
        });
      }
      if (importe < 0) {
        importe = 0;
        return importe.toFixed(2);
      } else {
        return importe.toFixed(2);
      }
     
    }
  },
  mounted() {}
};
</script>

<style scoped>
.table {
  font-size: 0.85em !important;
}
.table th,
td {
  padding-top: 5px !important ;
  padding-bottom: 5px !important;
}
.bg-total {
  background-color: coral;
}
</style>